export default __webpack_public_path__ + "static/media/statistics.a70ab246.svg";